// import 'grapesjs/dist/css/grapes.min.css';
// import gjspresetwebpage from 'grapesjs-preset-webpage';
// import gjsblockbasic from 'grapesjs-blocks-basic';
// import gjsblockflex from 'grapesjs-blocks-flexbox';
// import formsplugin from 'grapesjs-plugin-forms';
// import {GrapesjsReact} from 'grapesjs-react';
// import 'grapesjs-plugin-toolbox/dist/grapesjs-plugin-toolbox.min.css';
// import toolbox from 'grapesjs-plugin-toolbox';
// import grapesjsuserblock from 'grapesjs-user-blocks';
export const WebEditor = () => {
  return (
    <GrapesjsReact
      id="grapesjs-react"
      plugins={[
        gjspresetwebpage,
        gjsblockbasic,
        gjsblockflex,
        formsplugin,
        toolbox,
        grapesjsuserblock,
      ]}
    />
  );
};
